module.exports = __webpack_public_path__ + "img/121.04b61b2f.jpg";